// Full country list for the location switcher. cur = ISO currency, sym = display symbol.
export const COUNTRIES = [
  { code: "GB", label: "United Kingdom", flag: "🇬🇧", cur: "GBP", sym: "£" },
  { code: "BW", label: "Botswana", flag: "🇧🇼", cur: "BWP", sym: "P" },
  { code: "ZM", label: "Zambia", flag: "🇿🇲", cur: "ZMW", sym: "K" },
  { code: "NA", label: "Namibia", flag: "🇳🇦", cur: "NAD", sym: "N$" },
  { code: "ZA", label: "South Africa", flag: "🇿🇦", cur: "ZAR", sym: "R" },
  { code: "ZW", label: "Zimbabwe", flag: "🇿🇼", cur: "USD", sym: "$" },
  { code: "MW", label: "Malawi", flag: "🇲🇼", cur: "MWK", sym: "MK" },
  { code: "MZ", label: "Mozambique", flag: "🇲🇿", cur: "MZN", sym: "MT" },
  { code: "AO", label: "Angola", flag: "🇦🇴", cur: "AOA", sym: "Kz" },
  { code: "LS", label: "Lesotho", flag: "🇱🇸", cur: "LSL", sym: "L" },
  { code: "SZ", label: "Eswatini", flag: "🇸🇿", cur: "SZL", sym: "E" },
  { code: "KE", label: "Kenya", flag: "🇰🇪", cur: "KES", sym: "KSh" },
  { code: "TZ", label: "Tanzania", flag: "🇹🇿", cur: "TZS", sym: "TSh" },
  { code: "UG", label: "Uganda", flag: "🇺🇬", cur: "UGX", sym: "USh" },
  { code: "RW", label: "Rwanda", flag: "🇷🇼", cur: "RWF", sym: "FRw" },
  { code: "NG", label: "Nigeria", flag: "🇳🇬", cur: "NGN", sym: "₦" },
  { code: "GH", label: "Ghana", flag: "🇬🇭", cur: "GHS", sym: "₵" },
  { code: "ET", label: "Ethiopia", flag: "🇪🇹", cur: "ETB", sym: "Br" },
  { code: "EG", label: "Egypt", flag: "🇪🇬", cur: "EGP", sym: "£" },
  { code: "MA", label: "Morocco", flag: "🇲🇦", cur: "MAD", sym: "DH" },
  { code: "CM", label: "Cameroon", flag: "🇨🇲", cur: "XAF", sym: "FCFA" },
  { code: "CI", label: "Côte d'Ivoire", flag: "🇨🇮", cur: "XOF", sym: "CFA" },
  { code: "SN", label: "Senegal", flag: "🇸🇳", cur: "XOF", sym: "CFA" },
  { code: "CD", label: "DR Congo", flag: "🇨🇩", cur: "CDF", sym: "FC" },
  { code: "IE", label: "Ireland", flag: "🇮🇪", cur: "EUR", sym: "€" },
  { code: "US", label: "United States", flag: "🇺🇸", cur: "USD", sym: "$" },
  { code: "CA", label: "Canada", flag: "🇨🇦", cur: "CAD", sym: "C$" },
  { code: "AU", label: "Australia", flag: "🇦🇺", cur: "AUD", sym: "A$" },
  { code: "NZ", label: "New Zealand", flag: "🇳🇿", cur: "NZD", sym: "NZ$" },
  { code: "FR", label: "France", flag: "🇫🇷", cur: "EUR", sym: "€" },
  { code: "DE", label: "Germany", flag: "🇩🇪", cur: "EUR", sym: "€" },
  { code: "ES", label: "Spain", flag: "🇪🇸", cur: "EUR", sym: "€" },
  { code: "IT", label: "Italy", flag: "🇮🇹", cur: "EUR", sym: "€" },
  { code: "PT", label: "Portugal", flag: "🇵🇹", cur: "EUR", sym: "€" },
  { code: "NL", label: "Netherlands", flag: "🇳🇱", cur: "EUR", sym: "€" },
  { code: "BE", label: "Belgium", flag: "🇧🇪", cur: "EUR", sym: "€" },
  { code: "SE", label: "Sweden", flag: "🇸🇪", cur: "SEK", sym: "kr" },
  { code: "NO", label: "Norway", flag: "🇳🇴", cur: "NOK", sym: "kr" },
  { code: "CH", label: "Switzerland", flag: "🇨🇭", cur: "CHF", sym: "CHF" },
  { code: "PL", label: "Poland", flag: "🇵🇱", cur: "PLN", sym: "zł" },
  { code: "AE", label: "United Arab Emirates", flag: "🇦🇪", cur: "AED", sym: "د.إ" },
  { code: "SA", label: "Saudi Arabia", flag: "🇸🇦", cur: "SAR", sym: "﷼" },
  { code: "QA", label: "Qatar", flag: "🇶🇦", cur: "QAR", sym: "﷼" },
  { code: "IN", label: "India", flag: "🇮🇳", cur: "INR", sym: "₹" },
  { code: "PK", label: "Pakistan", flag: "🇵🇰", cur: "PKR", sym: "₨" },
  { code: "BD", label: "Bangladesh", flag: "🇧🇩", cur: "BDT", sym: "৳" },
  { code: "CN", label: "China", flag: "🇨🇳", cur: "CNY", sym: "¥" },
  { code: "JP", label: "Japan", flag: "🇯🇵", cur: "JPY", sym: "¥" },
  { code: "PH", label: "Philippines", flag: "🇵🇭", cur: "PHP", sym: "₱" },
  { code: "BR", label: "Brazil", flag: "🇧🇷", cur: "BRL", sym: "R$" },
  { code: "OTHER", label: "Elsewhere / Rest of world", flag: "🌍", cur: "GBP", sym: "£" },
];

const BY_CODE = Object.fromEntries(COUNTRIES.map((c) => [c.code, c]));
export const getCountry = (code) => BY_CODE[code] || BY_CODE.GB;

// Southern African countries → Jobs "Southern Africa" region.
const SOUTHERN_AFRICA = ["BW", "ZM", "NA", "ZA", "ZW", "MW", "MZ", "AO", "LS", "SZ"];

export function jobsRegionForCountry(code) {
  if (code === "GB") return "United Kingdom";
  if (SOUTHERN_AFRICA.includes(code)) return "Southern Africa";
  return "All regions";
}

// Jobs supports GBP / BWP / ZMW / ZAR display; map others to a sensible default.
export function jobsCurrencyForCountry(code) {
  if (code === "BW") return "BWP";
  if (code === "ZM") return "ZMW";
  if (["ZA", "NA", "LS", "SZ", "ZW"].includes(code)) return "ZAR";
  return "GBP";
}
